<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Map.scss";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

 .alert-float{
    left: -3px;
    position: absolute;
    top:-1px;
  }

  .container-symbology{
    padding: 10px;
    width: auto;
  }

  .vs-radio--borde{
    border: 2px solid #FFFF!important;
  }

  .device-info>.shadow-drop{
    padding-top: 0.5rem!important;
    padding-bottom: 0.5rem!important;
  }

  .cursor-ponter:hover{
    cursor: pointer;
  }

  .container-circuits{
    max-height: 150px;
    overflow-y: auto;
  }

  .container-alerts-control{
    display: grid;
    gap: 5px;
    grid-template-columns: repeat( 4, minmax(100px, 1fr) );
    grid-template-rows: auto;
    justify-content: space-evenly;
  }

  .vs-radio--borde{
    border: 2px solid #626262 !important;
  }

  .container-tags{
    max-height: 100px;
    max-width: calc(100% - 60px);
    overflow-y: auto;
  }

  .con-vs-slider{
    min-width: 50px!important;
    width:100px!important;
  }

  .leaflet-topcenter {
    position: absolute;
    top: 0px;
    left: 183px;
    width: calc(100% - 183px)
  }

  .container-schedules{
    max-height: 150px;
    overflow-y: auto;
    padding-bottom: 16px;
  }

  .container-schedule{
    border-bottom: 2px solid #f0f0f0;
  }

</style>
<template>
  <div class="item-grid-view vx-row match-height mt-4">
    <div class="vx-col w-full">
      <vx-card class="grid-view-item mb-base overflow-hidden">
        <div id="container-map" v-if="status_mapa">
            <l-map style="height: 100%; overflow: hidden;" :zoom="17" :center="center" ref="mymap">
                <l-control position="bottomleft">
                </l-control>
                <l-control position="bottomright">
                </l-control>
                <l-control position="verticalcenterright" class="leaflet-topcenter">
                </l-control>
                <l-control-layers
                  :position="layersPosition"
                  :collapsed="true"
                  :sort-layers="true"
                />
                <l-control :position="layersPosition">
                </l-control>
                <l-tile-layer
                    v-for="tileProvider in tileProviders"
                    :key="tileProvider.name"
                    :name="tileProvider.name"
                    :visible="tileProvider.visible"
                    :url="tileProvider.url"
                    layer-type="base"
                />

                <!--<v-marker-cluster>-->
                  <l-marker
                    v-for="marker in markers"
                    :key="marker.alias"
                    :visible="marker.visible"
                    @click="clickMarker(marker)"
                  >
                    <l-icon :icon-anchor="staticAnchor" class-name="someExtraClass">
                      <iconMarkerSelected  v-if="markersSelected.find(element => element.uuid == marker.uuid)" width="30" height="30" :iconColor="marker.circuit != null ? marker.circuit.color:'#000000'" />
                      <iconMarker  v-else width="25" height="25" :iconColor="marker.circuit != null ? marker.circuit.color:'#000000'" />
                    </l-icon>

                    <l-popup>
                    </l-popup>

                  </l-marker>
                <!--</v-marker-cluster>-->
            </l-map>
            <div class="text-xs my-1">{{$t('Messages.SelectArea')}}</div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
// import { request } from '@/request.js'
import {
  LMap,
  LMarker,
  LIcon,
  LPopup,
  LControl,
  LControlLayers
} from 'vue2-leaflet'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
import 'leaflet/dist/leaflet.css'
import 'leaflet-area-select'
import iconMarker from '@/components/icons/iconMarker'
import iconMarkerSelected from '@/components/icons/iconMarkerSelected'
/* global L:true */

const DATA = {
  code: 200,
  data: {
    count: 2,
    rows: [
      {
        uuid: 'cdfbacef-3540-41b5-aae3-448bcd330df4',
        deveui: '0011223344556677',
        serial: '1111111',
        alias: 'sensor 1 co2',
        label_location: 'en la biblioteca planta baja',
        notes: 'alguna nota extra no obligatiora',
        ppm_current: '800',
        ppm_max: '1000',
        ppm_min: '500',
        temp_current: '28.01',
        temp_max: '30.01',
        temp_min: '25.01',
        hum_current: '50',
        hum_max: '60',
        hum_min: '30',
        relay1_state: '0',
        relay2_state: '1',
        latlong: '20.6738686,-103.3704324',
        created_at: '2021-08-20 17:29:11',
        updated_at: '2021-08-23 11:08:06'
      },
      {
        uuid: 'cdfbacef-3540-41b5-aae3-448bcd450df4',
        deveui: '7766554433221100',
        serial: '222222',
        alias: 'sensor 2 co2',
        label_location: 'en la biblioteca planta alta',
        notes: 'alguna nota extra no obligatiora',
        ppm_current: '800',
        ppm_max: '1000',
        ppm_min: '500',
        temp_current: '28.01',
        temp_max: '30.01',
        temp_min: '25.01',
        hum_current: '50',
        hum_max: '60',
        hum_min: '30',
        relay1_state: '0',
        relay2_state: '1',
        latlong: '20.6738686,-103.3704345',
        created_at: '2021-08-20 17:29:11',
        updated_at: '2021-08-23 11:08:06'
      }
    ]
  },
  msg: 'Ok'
}

const tileProviders = [
  {
    name: 'Gris',
    visible: true,
    url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'
  },
  {
    name: 'Calles',
    visible: false,
    url: 'https://{s}.tile.openstreetmap.fr/osmfr//{z}/{x}/{y}.png'
  },
  {
    name: 'Satelite',
    visible: false,
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png'
  }
]

export default {
  name: 'mapa',
  components: {
    LMap,
    LMarker,
    LControl,
    LPopup,
    LIcon,
    LControlLayers,
    iconMarkerSelected,
    iconMarker
  },
  data () {
    return {
      latlngs: [],
      filters: {
      },
      tileProviders,
      layersPosition: 'topright',
      center: [],
      staticAnchor: [12, 27],
      customText: 'Gateway',
      imagePath: 'images/vendor/leaflet/dist/',
      response: [],
      markers: [],
      status_mapa: false,
      status_heat: false,
      haveFullScreen: false,
      getAll: true,
      selectMarkers: false,
      markersSelected: [],
      data: DATA
    }
  },
  methods: {
    async getMapa () {
      /* this.$vs.loading()
      this.selectMarkers = false

      const params = {
        url: 'co2_devices/map',
        method: 'GET',
        params: this.filters
      }
      await request(params).then(response => { */
      this.response = this.data.data.rows
      console.log(this.response)
      const positions = []
      this.markers = []
      for (let i = 0; i < this.response.length; i++) {
        if (this.response[i].latlong !== '') {
          positions.push([this.response[i].latlong.split(',')[0], this.response[i].latlong.split(',')[1]])
          this.markers.push({
            position: { lat: this.response[i].latlong.split(',')[0], lng: this.response[i].latlong.split(',')[1] },
            updatedAt: this.response[i].updated_at,
            uuid: this.response[i].uuid,
            serie: this.response[i].serial,
            draggable: false,
            visible: true
          })
        }
      }

      this.status_mapa = true
      // this.$vs.loading.close()
      const app = this
      setTimeout(function () {
        const maps = app.$refs.mymap.mapObject
        if (!app.haveFullScreen) {
          maps.addControl(new L.Control.Fullscreen())
          app.haveFullScreen = true
          /* maps.selectArea.enable()
            maps.on('areaselected', (e) => {
              app.selectMarkers = true
              app.markersSelected = app.markers.filter(item => {
                return e.bounds.contains(item.position)
              })
            }) */
        }
        maps.fitBounds(positions)
      }, 1000)
      /* }).catch(() => {
        this.center = [19.25101358132845, -103.69481138016101]
        this.markers = []
        this.status_mapa = true
      }).finally(() => {
        this.$vs.loading.close()
      }) */
    },
    clickMarker (item) {
      const found = this.markersSelected.find(element => element.uuid === item.uuid)
      if (this.selectMarkers && found === undefined) {
        this.markersSelected.push(item)
      }
    },
    deleteSelected (item) {
      const filter = this.markersSelected.filter(element => element.uuid !== item.uuid)
      this.markersSelected = filter
    }
  },
  created () {
    this.getMapa()
  },
  watch: {
    selectMarkers (val) {
      if (!val) {
        this.markersSelected = []
      }
    }
  }
}
</script>
